module.exports = __webpack_public_path__ + "static/media/ig-ok.882b709f.svg";